import { CellModel, ColumnSource, RequestFilters, RowSource } from "@omegagrid/grid";
import { msg } from "@omegagrid/localize";
import { ColorTypes } from "@omegagrid/core";
import { GridEditorAdapter, GridEditorOptions, RequestParamsOrder, RowData } from "@reporting/rp-app-host";
import { Project } from '@reporting/rp-types/ext';
import rp from '@reporting/rp-app-host';
import { formatProject, projectVersions } from "../utils";

const DEFAULT_FIELDS = ['id_custom_page', 'name', 'version'];
const DEFAULT_ORDER: RequestParamsOrder = [['name', 'asc']];

export class ProjectGridEditorAdapter extends GridEditorAdapter {

	private _columns: ColumnSource[];

	constructor() { super() }

	async getColumns(): Promise<ColumnSource[]> {
		if (this._columns) return this._columns;

		this._columns = [{
			t: 'a',
			e: false,
			w: 5 + 20 * 3,
			content: [{
				action: 'edit',
				icon: 'pen-to-square',
				color: ColorTypes.Blue,
				title: msg('Edit')
			}, {
				action: 'copy',
				icon: 'copy',
				color: ColorTypes.Green,
				title: msg('Copy project')
			}, {
				action: 'delete',
				icon: 'trash',
				color: ColorTypes.Red,
				title: msg('Delete')
			}],
			filter: false
		}, {
			data: 'id_custom_page',
			header: '#',
			t: 'n',
			z: '0',
			e: false,
			w: 80
		}, {
			data: 'name',
			header: msg('Name'),
			t: 't',
			e: true,
			w: 300
		}, {
			data: 'version',
			header: msg('Version'),
			t: 's',
			content: projectVersions.map(v => ({k: v, v: `v${v}`})),
			e: true,
			w: 60
		}];
		return this._columns;
	}

	async getRows(filters?: RequestFilters): Promise<RowSource[]>{
		const projects = await rp.ms('extensions').get<Project[]>(`projects`, this.createRequestParams(filters, {
			fields: DEFAULT_FIELDS,
			order: DEFAULT_ORDER,
		}));

		return projects.map(project => ({data: project}));
	}

	getOptions(): Partial<GridEditorOptions> {
		return this.createOptions({
			colLetters: false,
			columnSorting: true,
			filters: true,
			pageSize: 0,
			refreshAfterSave: true,
		});
	}

	onAction(action: string, cell: CellModel): void {
		const project = cell.row?.data as Project;
		if (!project?.id_custom_page) return;
		switch (action) {
			case 'edit':
				rp.host.openModalSidebar({
					id: `extensions-projectForm-${project.id_custom_page}`,
					caption: formatProject(project)
				});
				break;
			case 'copy':
				rp.host.openModalSidebar({
					id: `extensions-projectCopyForm-${project.id_custom_page}`,
					caption: `${msg('Copy project')}: ${formatProject(project)}`
				});
				break;
		}
	}

	async save(rowData: RowData[]) {
		const data = rowData.map(row => Object.assign({_state: row.state, _index: row.index}, row.data));
		await rp.ms('extensions').post(`projects`, data);
	}

}
